// extracted by mini-css-extract-plugin
module.exports = {"container":"game_container__WZRIz","gamePlace":"game_gamePlace__1tWyA","scorePlace":"game_scorePlace__2y_QV"};